export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
  large: 1440
}

export const EMITTER_PROPS = {
  cart: {
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    change: 'cart.change',
    render: 'cart.render'
  },
  giftOptions: {
    updated: 'giftOptions.updated'
  },
  product: {
    updateVariant: 'product.update_variant',
    updatePrice: 'product.update_price',
    updateSellingPlan: 'product.update_selling_plan',
    openModalGallery: 'product.open_modal_gallery',
    openModalBIS: 'product.open_modal_bis',
    addToCartError: 'product.add_to_cart_error',
    openModalBundle: 'product.open_modal_bundle',
    updateBundle: 'product.updateBundle'
  },
  notice: {
    global: 'notice.global'
  },
  slideout: {
    open: 'slideout.open'
  },
  modal: {
    close: 'modal.close',
    open: 'modal.open'
  },
  wishlist: {
    init: 'wishlist.init',
    change: 'wishlist.change'
  }
}

export const RECENTLY_CONFIG = {
  cookieName: 'gamma_recently_viewed', // Please change prefix every new project 'gamma_' to project name
  cookieSkusName: 'gamma_recently_viewed_skus', // Please change prefix every new project 'gamma_' to project name
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}

export const PURCHASE_OPTIONS = {
  ONE_TIME: 'one-time',
  SUBSCRIPTION: 'subscription'
}

export const PURCHASE_OPTION_LABELS = {
  [PURCHASE_OPTIONS.ONE_TIME]: 'One Time Purchase',
  [PURCHASE_OPTIONS.SUBSCRIPTION]: 'Subscribe and Save'
}

export const SAMPLE_CART_PROPERTY_KEY = '_isSample'

export const PRODUCT_TYPES = {
  VALUE_BUNDLE: 'Value Bundle'
}

export const BIS_ENDPOINT = {
  GET_ACCESS_TOKEN: 'https://2hrfu2sis6cfjbslmkh6aslv7e0zpesc.lambda-url.ap-southeast-2.on.aws',
  SUBMIT_FORM: 'https://api.au-aws.thewishlist.io/services/wsservice/api/wishlist/items/customerInterest'
}

export const BUNDLE_LIST_PROPERTY_KEY = '_rb_list_bundle'

export const BUNDLE_CART_KEY = '_isBundle'

export const GIFT_OPTION_CART_PROPERTY_KEY = '_gift_option'

export const GIFT_NOTE_CART_PROPERTY_KEY = 'gift-note'
